import { motion } from "framer-motion";

const REACTION_EMOJIS = ['👍', '❤️', '😂', '😮', '😢', '🎉'];

interface ReactionBarProps {
  onReact: (emoji: string) => void;
  position: 'left' | 'right';
}

export function ReactionBar({ onReact, position }: ReactionBarProps) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8, y: 10 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.8, y: 10 }}
      className={`absolute bottom-full mb-2 ${
        position === 'left' ? 'right-0' : 'left-0'
      } bg-background border rounded-full shadow-lg px-1.5 sm:px-2 py-1 flex items-center gap-0.5 z-50`}
    >
      {REACTION_EMOJIS.map((emoji) => (
        <motion.button
          key={emoji}
          whileHover={{ scale: 1.3 }}
          whileTap={{ scale: 0.9 }}
          className="text-base sm:text-lg hover:bg-muted rounded-full w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center transition-colors"
          onClick={(e) => {
            e.stopPropagation();
            onReact(emoji);
          }}
        >
          {emoji}
        </motion.button>
      ))}
    </motion.div>
  );
}
